import { GFORGE_MENTION_USER, MentionUser, MentionsService } from '../../../core/services/core.mentio.service';
import * as _ from 'lodash';

/**
 * Who is mentionable from a tracker item.
 *
 * Every tracker surface -- add, edit, the follow-up timeline, the edit modal --
 * answers this the same way, so they share one answer rather than four that
 * drifted apart. Anything a particular surface knows about and this function
 * cannot see (the members list on the add form, the follow-up authors on the
 * timeline) comes in through `extra`.
 */
export function trackerMentionUsers(
    mentionsService: MentionsService,
    tracker: any,
    trackeritem: any,
    extra: any[] = []
): MentionUser[] {
    const candidates: any[] = [
        // Everyone who could be assigned, and everyone who is
        ..._.get(tracker, 'rel.assignees', []),
        ..._.get(trackeritem, 'rel.assignees', []),
        // Creator / submitter
        trackeritem?.submittedBy,
        trackeritem?.createdBy,
        trackeritem?.rel?.createdBy,
        // Authors of existing history entries
        ...(_.get(trackeritem, 'rel.history', []) || []).map((item: any) => item?.user),
        // Whatever else the calling surface has on hand
        ...extra
    ];
    const users = _.uniqBy(
        candidates
            .flat()
            .filter((user: any) => user?.unixName)
            .map((user: any) => mentionsService.mapToMentionUser(user)),
        'unixName'
    );

    return [GFORGE_MENTION_USER, ...users].filter(
        (u, i, all) => all.findIndex(other => other.unixName === u.unixName) === i
    );
}
